import { storeWithExpiry } from "../../lib/localStorage";
import actions from "./addListing.actions";

export const initialState = {
  addListingData: {},
  categoryFields: {},
};

const expiryPeriod = 86400 * 1000 * 7;

export default function AddListingReducer(state, action) {
  switch (action.type) {
    case actions.SET_ADD_LISTING_DATA:
      storeWithExpiry(
        "addListingData",
        {
          ...state.addListingData,
          ...action.payload,
        },
        expiryPeriod
      );
      return {
        ...state,
        addListingData: { ...state.addListingData, ...action.payload },
      };
    case actions.SET_CATEGORY_FIELDS:
      storeWithExpiry(
        "addingListingCategoryFieldsConfig",
        action.payload,
        expiryPeriod
      );
      return {
        ...state,
        categoryFields: action.payload,
      };
    case actions.RESET_LISTING_DATA:
      storeWithExpiry("addListingData", action.payload, expiryPeriod);
      return {
        ...state,
        addListingData: action.payload,
      };
    case actions.CLEAR_ADD_LISTING_DATA:
      storeWithExpiry("addListingData", {}, expiryPeriod);
      storeWithExpiry("addingListingCategoryFieldsConfig", {}, expiryPeriod);
      return {
        ...state,
        addListingData: {},
        categoryFields: {},
      };
    default:
      throw new Error("Unsupported action type at fav listings reducer");
  }
}
